/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import type {IconComponent} from '../types'
import {AccessDeniedIcon} from './accessDeniedIcon'
import {ActivityIcon} from './activityIcon'
import {AddCircleIcon} from './addCircleIcon'
import {AddCommentIcon} from './addCommentIcon'
import {AddDocumentIcon} from './addDocumentIcon'
import {AddIcon} from './addIcon'
import {AddUserIcon} from './addUserIcon'
import {ApiIcon} from './apiIcon'
import {ArchiveIcon} from './archiveIcon'
import {ArrowDownIcon} from './arrowDownIcon'
import {ArrowLeftIcon} from './arrowLeftIcon'
import {ArrowRightIcon} from './arrowRightIcon'
import {ArrowTopRightIcon} from './arrowTopRightIcon'
import {ArrowUpIcon} from './arrowUpIcon'
import {AsteriskIcon} from './asteriskIcon'
import {BarChartIcon} from './barChartIcon'
import {BasketIcon} from './basketIcon'
import {BellIcon} from './bellIcon'
import {BillIcon} from './billIcon'
import {BinaryDocumentIcon} from './binaryDocumentIcon'
import {BlockContentIcon} from './blockContentIcon'
import {BlockElementIcon} from './blockElementIcon'
import {BlockquoteIcon} from './blockquoteIcon'
import {BoldIcon} from './boldIcon'
import {BoltIcon} from './boltIcon'
import {BookIcon} from './bookIcon'
import {BookmarkFilledIcon} from './bookmarkFilledIcon'
import {BookmarkIcon} from './bookmarkIcon'
import {BottleIcon} from './bottleIcon'
import {BugIcon} from './bugIcon'
import {BulbFilledIcon} from './bulbFilledIcon'
import {BulbOutlineIcon} from './bulbOutlineIcon'
import {CalendarIcon} from './calendarIcon'
import {CaseIcon} from './caseIcon'
import {ChartUpwardIcon} from './chartUpwardIcon'
import {CheckmarkCircleIcon} from './checkmarkCircleIcon'
import {CheckmarkIcon} from './checkmarkIcon'
import {ChevronDownIcon} from './chevronDownIcon'
import {ChevronLeftIcon} from './chevronLeftIcon'
import {ChevronRightIcon} from './chevronRightIcon'
import {ChevronUpIcon} from './chevronUpIcon'
import {CircleIcon} from './circleIcon'
import {ClipboardIcon} from './clipboardIcon'
import {ClipboardImageIcon} from './clipboardImageIcon'
import {ClockIcon} from './clockIcon'
import {CloseCircleIcon} from './closeCircleIcon'
import {CloseIcon} from './closeIcon'
import {CodeBlockIcon} from './codeBlockIcon'
import {CodeIcon} from './codeIcon'
import {CogIcon} from './cogIcon'
import {CollapseIcon} from './collapseIcon'
import {ColorWheelIcon} from './colorWheelIcon'
import {CommentIcon} from './commentIcon'
import {ComponentIcon} from './componentIcon'
import {ComposeIcon} from './composeIcon'
import {ComposeSparklesIcon} from './composeSparklesIcon'
import {ConfettiIcon} from './confettiIcon'
import {ControlsIcon} from './controlsIcon'
import {CopyIcon} from './copyIcon'
import {CreditCardIcon} from './creditCardIcon'
import {CropIcon} from './cropIcon'
import {CubeIcon} from './cubeIcon'
import {DashboardIcon} from './dashboardIcon'
import {DatabaseIcon} from './databaseIcon'
import {DesktopIcon} from './desktopIcon'
import {DiamondIcon} from './diamondIcon'
import {DocumentIcon} from './documentIcon'
import {DocumentPdfIcon} from './documentPdfIcon'
import {DocumentRemoveIcon} from './documentRemoveIcon'
import {DocumentSheetIcon} from './documentSheetIcon'
import {DocumentsIcon} from './documentsIcon'
import {DocumentTextIcon} from './documentTextIcon'
import {DocumentVideoIcon} from './documentVideoIcon'
import {DocumentWordIcon} from './documentWordIcon'
import {DocumentZipIcon} from './documentZipIcon'
import {DotIcon} from './dotIcon'
import {DoubleChevronDownIcon} from './doubleChevronDownIcon'
import {DoubleChevronLeftIcon} from './doubleChevronLeftIcon'
import {DoubleChevronRightIcon} from './doubleChevronRightIcon'
import {DoubleChevronUpIcon} from './doubleChevronUpIcon'
import {DownloadIcon} from './downloadIcon'
import {DragHandleIcon} from './dragHandleIcon'
import {DropIcon} from './dropIcon'
import {EarthAmericasIcon} from './earthAmericasIcon'
import {EarthGlobeIcon} from './earthGlobeIcon'
import {EditIcon} from './editIcon'
import {EllipsisHorizontalIcon} from './ellipsisHorizontalIcon'
import {EllipsisVerticalIcon} from './ellipsisVerticalIcon'
import {EmptyIcon} from './emptyIcon'
import {EnterIcon} from './enterIcon'
import {EnterRightIcon} from './enterRightIcon'
import {EnvelopeIcon} from './envelopeIcon'
import {EqualIcon} from './equalIcon'
import {ErrorFilledIcon} from './errorFilledIcon'
import {ErrorOutlineIcon} from './errorOutlineIcon'
import {ErrorScreenIcon} from './errorScreenIcon'
import {ExpandIcon} from './expandIcon'
import {EyeClosedIcon} from './eyeClosedIcon'
import {EyeOpenIcon} from './eyeOpenIcon'
import {FaceHappyIcon} from './faceHappyIcon'
import {FaceIndifferentIcon} from './faceIndifferentIcon'
import {FaceSadIcon} from './faceSadIcon'
import {FeedbackIcon} from './feedbackIcon'
import {FilterIcon} from './filterIcon'
import {FolderIcon} from './folderIcon'
import {GenerateIcon} from './generateIcon'
import {GithubIcon} from './githubIcon'
import {GroqIcon} from './groqIcon'
import {HashIcon} from './hashIcon'
import {HeartFilledIcon} from './heartFilledIcon'
import {HeartIcon} from './heartIcon'
import {HelpCircleIcon} from './helpCircleIcon'
import {HighlightIcon} from './highlightIcon'
import {HomeIcon} from './homeIcon'
import {IceCreamIcon} from './iceCreamIcon'
import {ImageIcon} from './imageIcon'
import {ImageRemoveIcon} from './imageRemoveIcon'
import {ImagesIcon} from './imagesIcon'
import {InboxIcon} from './inboxIcon'
import {InfoFilledIcon} from './infoFilledIcon'
import {InfoOutlineIcon} from './infoOutlineIcon'
import {InlineElementIcon} from './inlineElementIcon'
import {InlineIcon} from './inlineIcon'
import {InsertAboveIcon} from './insertAboveIcon'
import {InsertBelowIcon} from './insertBelowIcon'
import {ItalicIcon} from './italicIcon'
import {JoystickIcon} from './joystickIcon'
import {JsonIcon} from './jsonIcon'
import {LaunchIcon} from './launchIcon'
import {LeaveIcon} from './leaveIcon'
import {LemonIcon} from './lemonIcon'
import {LinkedinIcon} from './linkedinIcon'
import {LinkIcon} from './linkIcon'
import {LinkRemovedIcon} from './linkRemovedIcon'
import {ListIcon} from './listIcon'
import {LockIcon} from './lockIcon'
import {LogoJsIcon} from './logoJsIcon'
import {LogoTsIcon} from './logoTsIcon'
import {MarkerIcon} from './markerIcon'
import {MarkerRemovedIcon} from './markerRemovedIcon'
import {MasterDetailIcon} from './masterDetailIcon'
import {MenuIcon} from './menuIcon'
import {MicrophoneIcon} from './microphoneIcon'
import {MicrophoneSlashIcon} from './microphoneSlashIcon'
import {MobileDeviceIcon} from './mobileDeviceIcon'
import {MoonIcon} from './moonIcon'
import {NumberIcon} from './numberIcon'
import {OkHandIcon} from './okHandIcon'
import {OlistIcon} from './olistIcon'
import {OverageIcon} from './overageIcon'
import {PackageIcon} from './packageIcon'
import {PanelLeftIcon} from './panelLeftIcon'
import {PanelRightIcon} from './panelRightIcon'
import {PauseIcon} from './pauseIcon'
import {PinFilledIcon} from './pinFilledIcon'
import {PinIcon} from './pinIcon'
import {PinRemovedIcon} from './pinRemovedIcon'
import {PlayIcon} from './playIcon'
import {PlugIcon} from './plugIcon'
import {PresentationIcon} from './presentationIcon'
import {Progress50Icon} from './progress50Icon'
import {Progress75Icon} from './progress75Icon'
import {ProjectsIcon} from './projectsIcon'
import {PublishIcon} from './publishIcon'
import {ReadOnlyIcon} from './readOnlyIcon'
import {RedoIcon} from './redoIcon'
import {RefreshIcon} from './refreshIcon'
import {RemoveCircleIcon} from './removeCircleIcon'
import {RemoveIcon} from './removeIcon'
import {ResetIcon} from './resetIcon'
import {RestoreIcon} from './restoreIcon'
import {RetrieveIcon} from './retrieveIcon'
import {RetryIcon} from './retryIcon'
import {RevertIcon} from './revertIcon'
import {RobotIcon} from './robotIcon'
import {RocketIcon} from './rocketIcon'
import {SchemaIcon} from './schemaIcon'
import {SearchIcon} from './searchIcon'
import {SelectIcon} from './selectIcon'
import {ShareIcon} from './shareIcon'
import {SortIcon} from './sortIcon'
import {SparkleIcon} from './sparkleIcon'
import {SparklesIcon} from './sparklesIcon'
import {SpinnerIcon} from './spinnerIcon'
import {SplitHorizontalIcon} from './splitHorizontalIcon'
import {SplitVerticalIcon} from './splitVerticalIcon'
import {SquareIcon} from './squareIcon'
import {StackCompactIcon} from './stackCompactIcon'
import {StackIcon} from './stackIcon'
import {StarFilledIcon} from './starFilledIcon'
import {StarIcon} from './starIcon'
import {StopIcon} from './stopIcon'
import {StrikethroughIcon} from './strikethroughIcon'
import {StringIcon} from './stringIcon'
import {SunIcon} from './sunIcon'
import {SyncIcon} from './syncIcon'
import {TabletDeviceIcon} from './tabletDeviceIcon'
import {TagIcon} from './tagIcon'
import {TagsIcon} from './tagsIcon'
import {TargetIcon} from './targetIcon'
import {TaskIcon} from './taskIcon'
import {TerminalIcon} from './terminalIcon'
import {TextIcon} from './textIcon'
import {ThLargeIcon} from './thLargeIcon'
import {ThListIcon} from './thListIcon'
import {ThumbsDownIcon} from './thumbsDownIcon'
import {ThumbsUpIcon} from './thumbsUpIcon'
import {TiersIcon} from './tiersIcon'
import {TimelineIcon} from './timelineIcon'
import {ToggleArrowRightIcon} from './toggleArrowRightIcon'
import {TokenIcon} from './tokenIcon'
import {TransferIcon} from './transferIcon'
import {TranslateIcon} from './translateIcon'
import {TrashIcon} from './trashIcon'
import {TrendUpwardIcon} from './trendUpwardIcon'
import {TriangleOutlineIcon} from './triangleOutlineIcon'
import {TrolleyIcon} from './trolleyIcon'
import {TruncateIcon} from './truncateIcon'
import {TwitterIcon} from './twitterIcon'
import {UlistIcon} from './ulistIcon'
import {UnarchiveIcon} from './unarchiveIcon'
import {UnderlineIcon} from './underlineIcon'
import {UndoIcon} from './undoIcon'
import {UnknownIcon} from './unknownIcon'
import {UnlinkIcon} from './unlinkIcon'
import {UnlockIcon} from './unlockIcon'
import {UnpublishIcon} from './unpublishIcon'
import {UploadIcon} from './uploadIcon'
import {UserIcon} from './userIcon'
import {UsersIcon} from './usersIcon'
import {VersionsIcon} from './versionsIcon'
import {VideoIcon} from './videoIcon'
import {WarningFilledIcon} from './warningFilledIcon'
import {WarningOutlineIcon} from './warningOutlineIcon'
import {WrenchIcon} from './wrenchIcon'

/**
 * @public
 */
export type IconSymbol =
  | 'access-denied'
  | 'activity'
  | 'add-circle'
  | 'add-comment'
  | 'add-document'
  | 'add'
  | 'add-user'
  | 'api'
  | 'archive'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-top-right'
  | 'arrow-up'
  | 'asterisk'
  | 'bar-chart'
  | 'basket'
  | 'bell'
  | 'bill'
  | 'binary-document'
  | 'block-content'
  | 'block-element'
  | 'blockquote'
  | 'bold'
  | 'bolt'
  | 'book'
  | 'bookmark-filled'
  | 'bookmark'
  | 'bottle'
  | 'bug'
  | 'bulb-filled'
  | 'bulb-outline'
  | 'calendar'
  | 'case'
  | 'chart-upward'
  | 'checkmark-circle'
  | 'checkmark'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'circle'
  | 'clipboard'
  | 'clipboard-image'
  | 'clock'
  | 'close-circle'
  | 'close'
  | 'code-block'
  | 'code'
  | 'cog'
  | 'collapse'
  | 'color-wheel'
  | 'comment'
  | 'component'
  | 'compose'
  | 'compose-sparkles'
  | 'confetti'
  | 'controls'
  | 'copy'
  | 'credit-card'
  | 'crop'
  | 'cube'
  | 'dashboard'
  | 'database'
  | 'desktop'
  | 'diamond'
  | 'document'
  | 'document-pdf'
  | 'document-remove'
  | 'document-sheet'
  | 'document-text'
  | 'document-video'
  | 'document-word'
  | 'document-zip'
  | 'documents'
  | 'dot'
  | 'double-chevron-down'
  | 'double-chevron-left'
  | 'double-chevron-right'
  | 'double-chevron-up'
  | 'download'
  | 'drag-handle'
  | 'drop'
  | 'earth-americas'
  | 'earth-globe'
  | 'edit'
  | 'ellipsis-horizontal'
  | 'ellipsis-vertical'
  | 'empty'
  | 'enter'
  | 'enter-right'
  | 'envelope'
  | 'equal'
  | 'error-filled'
  | 'error-outline'
  | 'error-screen'
  | 'expand'
  | 'eye-closed'
  | 'eye-open'
  | 'face-happy'
  | 'face-indifferent'
  | 'face-sad'
  | 'feedback'
  | 'filter'
  | 'folder'
  | 'generate'
  | 'github'
  | 'groq'
  | 'hash'
  | 'heart-filled'
  | 'heart'
  | 'help-circle'
  | 'highlight'
  | 'home'
  | 'ice-cream'
  | 'image'
  | 'image-remove'
  | 'images'
  | 'inbox'
  | 'info-filled'
  | 'info-outline'
  | 'inline-element'
  | 'inline'
  | 'insert-above'
  | 'insert-below'
  | 'italic'
  | 'joystick'
  | 'json'
  | 'launch'
  | 'leave'
  | 'lemon'
  | 'link'
  | 'link-removed'
  | 'linkedin'
  | 'list'
  | 'lock'
  | 'logo-js'
  | 'logo-ts'
  | 'marker'
  | 'marker-removed'
  | 'master-detail'
  | 'menu'
  | 'microphone'
  | 'microphone-slash'
  | 'mobile-device'
  | 'moon'
  | 'number'
  | 'ok-hand'
  | 'olist'
  | 'overage'
  | 'package'
  | 'panel-left'
  | 'panel-right'
  | 'pause'
  | 'pin-filled'
  | 'pin'
  | 'pin-removed'
  | 'play'
  | 'plug'
  | 'presentation'
  | 'progress-50'
  | 'progress-75'
  | 'projects'
  | 'publish'
  | 'read-only'
  | 'redo'
  | 'refresh'
  | 'remove-circle'
  | 'remove'
  | 'reset'
  | 'restore'
  | 'retrieve'
  | 'retry'
  | 'revert'
  | 'robot'
  | 'rocket'
  | 'schema'
  | 'search'
  | 'select'
  | 'share'
  | 'sort'
  | 'sparkle'
  | 'sparkles'
  | 'spinner'
  | 'split-horizontal'
  | 'split-vertical'
  | 'square'
  | 'stack-compact'
  | 'stack'
  | 'star-filled'
  | 'star'
  | 'stop'
  | 'strikethrough'
  | 'string'
  | 'sun'
  | 'sync'
  | 'tablet-device'
  | 'tag'
  | 'tags'
  | 'target'
  | 'task'
  | 'terminal'
  | 'text'
  | 'th-large'
  | 'th-list'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'tiers'
  | 'timeline'
  | 'toggle-arrow-right'
  | 'token'
  | 'transfer'
  | 'translate'
  | 'trash'
  | 'trend-upward'
  | 'triangle-outline'
  | 'trolley'
  | 'truncate'
  | 'twitter'
  | 'ulist'
  | 'unarchive'
  | 'underline'
  | 'undo'
  | 'unknown'
  | 'unlink'
  | 'unlock'
  | 'unpublish'
  | 'upload'
  | 'user'
  | 'users'
  | 'versions'
  | 'video'
  | 'warning-filled'
  | 'warning-outline'
  | 'wrench'

export {
  AccessDeniedIcon,
  ActivityIcon,
  AddCircleIcon,
  AddCommentIcon,
  AddDocumentIcon,
  AddIcon,
  AddUserIcon,
  ApiIcon,
  ArchiveIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowTopRightIcon,
  ArrowUpIcon,
  AsteriskIcon,
  BarChartIcon,
  BasketIcon,
  BellIcon,
  BillIcon,
  BinaryDocumentIcon,
  BlockContentIcon,
  BlockElementIcon,
  BlockquoteIcon,
  BoldIcon,
  BoltIcon,
  BookIcon,
  BookmarkFilledIcon,
  BookmarkIcon,
  BottleIcon,
  BugIcon,
  BulbFilledIcon,
  BulbOutlineIcon,
  CalendarIcon,
  CaseIcon,
  ChartUpwardIcon,
  CheckmarkCircleIcon,
  CheckmarkIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CircleIcon,
  ClipboardIcon,
  ClipboardImageIcon,
  ClockIcon,
  CloseCircleIcon,
  CloseIcon,
  CodeBlockIcon,
  CodeIcon,
  CogIcon,
  CollapseIcon,
  ColorWheelIcon,
  CommentIcon,
  ComponentIcon,
  ComposeIcon,
  ComposeSparklesIcon,
  ConfettiIcon,
  ControlsIcon,
  CopyIcon,
  CreditCardIcon,
  CropIcon,
  CubeIcon,
  DashboardIcon,
  DatabaseIcon,
  DesktopIcon,
  DiamondIcon,
  DocumentIcon,
  DocumentPdfIcon,
  DocumentRemoveIcon,
  DocumentSheetIcon,
  DocumentTextIcon,
  DocumentVideoIcon,
  DocumentWordIcon,
  DocumentZipIcon,
  DocumentsIcon,
  DotIcon,
  DoubleChevronDownIcon,
  DoubleChevronLeftIcon,
  DoubleChevronRightIcon,
  DoubleChevronUpIcon,
  DownloadIcon,
  DragHandleIcon,
  DropIcon,
  EarthAmericasIcon,
  EarthGlobeIcon,
  EditIcon,
  EllipsisHorizontalIcon,
  EllipsisVerticalIcon,
  EmptyIcon,
  EnterIcon,
  EnterRightIcon,
  EnvelopeIcon,
  EqualIcon,
  ErrorFilledIcon,
  ErrorOutlineIcon,
  ErrorScreenIcon,
  ExpandIcon,
  EyeClosedIcon,
  EyeOpenIcon,
  FaceHappyIcon,
  FaceIndifferentIcon,
  FaceSadIcon,
  FeedbackIcon,
  FilterIcon,
  FolderIcon,
  GenerateIcon,
  GithubIcon,
  GroqIcon,
  HashIcon,
  HeartFilledIcon,
  HeartIcon,
  HelpCircleIcon,
  HighlightIcon,
  HomeIcon,
  IceCreamIcon,
  ImageIcon,
  ImageRemoveIcon,
  ImagesIcon,
  InboxIcon,
  InfoFilledIcon,
  InfoOutlineIcon,
  InlineElementIcon,
  InlineIcon,
  InsertAboveIcon,
  InsertBelowIcon,
  ItalicIcon,
  JoystickIcon,
  JsonIcon,
  LaunchIcon,
  LeaveIcon,
  LemonIcon,
  LinkIcon,
  LinkRemovedIcon,
  LinkedinIcon,
  ListIcon,
  LockIcon,
  LogoJsIcon,
  LogoTsIcon,
  MarkerIcon,
  MarkerRemovedIcon,
  MasterDetailIcon,
  MenuIcon,
  MicrophoneIcon,
  MicrophoneSlashIcon,
  MobileDeviceIcon,
  MoonIcon,
  NumberIcon,
  OkHandIcon,
  OlistIcon,
  OverageIcon,
  PackageIcon,
  PanelLeftIcon,
  PanelRightIcon,
  PauseIcon,
  PinFilledIcon,
  PinIcon,
  PinRemovedIcon,
  PlayIcon,
  PlugIcon,
  PresentationIcon,
  Progress50Icon,
  Progress75Icon,
  ProjectsIcon,
  PublishIcon,
  ReadOnlyIcon,
  RedoIcon,
  RefreshIcon,
  RemoveCircleIcon,
  RemoveIcon,
  ResetIcon,
  RestoreIcon,
  RetrieveIcon,
  RetryIcon,
  RevertIcon,
  RobotIcon,
  RocketIcon,
  SchemaIcon,
  SearchIcon,
  SelectIcon,
  ShareIcon,
  SortIcon,
  SparkleIcon,
  SparklesIcon,
  SpinnerIcon,
  SplitHorizontalIcon,
  SplitVerticalIcon,
  SquareIcon,
  StackCompactIcon,
  StackIcon,
  StarFilledIcon,
  StarIcon,
  StopIcon,
  StrikethroughIcon,
  StringIcon,
  SunIcon,
  SyncIcon,
  TabletDeviceIcon,
  TagIcon,
  TagsIcon,
  TargetIcon,
  TaskIcon,
  TerminalIcon,
  TextIcon,
  ThLargeIcon,
  ThListIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  TiersIcon,
  TimelineIcon,
  ToggleArrowRightIcon,
  TokenIcon,
  TransferIcon,
  TranslateIcon,
  TrashIcon,
  TrendUpwardIcon,
  TriangleOutlineIcon,
  TrolleyIcon,
  TruncateIcon,
  TwitterIcon,
  UlistIcon,
  UnarchiveIcon,
  UnderlineIcon,
  UndoIcon,
  UnknownIcon,
  UnlinkIcon,
  UnlockIcon,
  UnpublishIcon,
  UploadIcon,
  UserIcon,
  UsersIcon,
  VersionsIcon,
  VideoIcon,
  WarningFilledIcon,
  WarningOutlineIcon,
  WrenchIcon,
}

/**
 * @public
 */
export interface IconMap {
  'access-denied': IconComponent
  'activity': IconComponent
  'add-circle': IconComponent
  'add-comment': IconComponent
  'add-document': IconComponent
  'add': IconComponent
  'add-user': IconComponent
  'api': IconComponent
  'archive': IconComponent
  'arrow-down': IconComponent
  'arrow-left': IconComponent
  'arrow-right': IconComponent
  'arrow-top-right': IconComponent
  'arrow-up': IconComponent
  'asterisk': IconComponent
  'bar-chart': IconComponent
  'basket': IconComponent
  'bell': IconComponent
  'bill': IconComponent
  'binary-document': IconComponent
  'block-content': IconComponent
  'block-element': IconComponent
  'blockquote': IconComponent
  'bold': IconComponent
  'bolt': IconComponent
  'book': IconComponent
  'bookmark-filled': IconComponent
  'bookmark': IconComponent
  'bottle': IconComponent
  'bug': IconComponent
  'bulb-filled': IconComponent
  'bulb-outline': IconComponent
  'calendar': IconComponent
  'case': IconComponent
  'chart-upward': IconComponent
  'checkmark-circle': IconComponent
  'checkmark': IconComponent
  'chevron-down': IconComponent
  'chevron-left': IconComponent
  'chevron-right': IconComponent
  'chevron-up': IconComponent
  'circle': IconComponent
  'clipboard': IconComponent
  'clipboard-image': IconComponent
  'clock': IconComponent
  'close-circle': IconComponent
  'close': IconComponent
  'code-block': IconComponent
  'code': IconComponent
  'cog': IconComponent
  'collapse': IconComponent
  'color-wheel': IconComponent
  'comment': IconComponent
  'component': IconComponent
  'compose': IconComponent
  'compose-sparkles': IconComponent
  'confetti': IconComponent
  'controls': IconComponent
  'copy': IconComponent
  'credit-card': IconComponent
  'crop': IconComponent
  'cube': IconComponent
  'dashboard': IconComponent
  'database': IconComponent
  'desktop': IconComponent
  'diamond': IconComponent
  'document': IconComponent
  'document-pdf': IconComponent
  'document-remove': IconComponent
  'document-sheet': IconComponent
  'document-text': IconComponent
  'document-video': IconComponent
  'document-word': IconComponent
  'document-zip': IconComponent
  'documents': IconComponent
  'dot': IconComponent
  'double-chevron-down': IconComponent
  'double-chevron-left': IconComponent
  'double-chevron-right': IconComponent
  'double-chevron-up': IconComponent
  'download': IconComponent
  'drag-handle': IconComponent
  'drop': IconComponent
  'earth-americas': IconComponent
  'earth-globe': IconComponent
  'edit': IconComponent
  'ellipsis-horizontal': IconComponent
  'ellipsis-vertical': IconComponent
  'empty': IconComponent
  'enter': IconComponent
  'enter-right': IconComponent
  'envelope': IconComponent
  'equal': IconComponent
  'error-filled': IconComponent
  'error-outline': IconComponent
  'error-screen': IconComponent
  'expand': IconComponent
  'eye-closed': IconComponent
  'eye-open': IconComponent
  'face-happy': IconComponent
  'face-indifferent': IconComponent
  'face-sad': IconComponent
  'feedback': IconComponent
  'filter': IconComponent
  'folder': IconComponent
  'generate': IconComponent
  'github': IconComponent
  'groq': IconComponent
  'hash': IconComponent
  'heart-filled': IconComponent
  'heart': IconComponent
  'help-circle': IconComponent
  'highlight': IconComponent
  'home': IconComponent
  'ice-cream': IconComponent
  'image': IconComponent
  'image-remove': IconComponent
  'images': IconComponent
  'inbox': IconComponent
  'info-filled': IconComponent
  'info-outline': IconComponent
  'inline-element': IconComponent
  'inline': IconComponent
  'insert-above': IconComponent
  'insert-below': IconComponent
  'italic': IconComponent
  'joystick': IconComponent
  'json': IconComponent
  'launch': IconComponent
  'leave': IconComponent
  'lemon': IconComponent
  'link': IconComponent
  'link-removed': IconComponent
  'linkedin': IconComponent
  'list': IconComponent
  'lock': IconComponent
  'logo-js': IconComponent
  'logo-ts': IconComponent
  'marker': IconComponent
  'marker-removed': IconComponent
  'master-detail': IconComponent
  'menu': IconComponent
  'microphone': IconComponent
  'microphone-slash': IconComponent
  'mobile-device': IconComponent
  'moon': IconComponent
  'number': IconComponent
  'ok-hand': IconComponent
  'olist': IconComponent
  'overage': IconComponent
  'package': IconComponent
  'panel-left': IconComponent
  'panel-right': IconComponent
  'pause': IconComponent
  'pin-filled': IconComponent
  'pin': IconComponent
  'pin-removed': IconComponent
  'play': IconComponent
  'plug': IconComponent
  'presentation': IconComponent
  'progress-50': IconComponent
  'progress-75': IconComponent
  'projects': IconComponent
  'publish': IconComponent
  'read-only': IconComponent
  'redo': IconComponent
  'refresh': IconComponent
  'remove-circle': IconComponent
  'remove': IconComponent
  'reset': IconComponent
  'restore': IconComponent
  'retrieve': IconComponent
  'retry': IconComponent
  'revert': IconComponent
  'robot': IconComponent
  'rocket': IconComponent
  'schema': IconComponent
  'search': IconComponent
  'select': IconComponent
  'share': IconComponent
  'sort': IconComponent
  'sparkle': IconComponent
  'sparkles': IconComponent
  'spinner': IconComponent
  'split-horizontal': IconComponent
  'split-vertical': IconComponent
  'square': IconComponent
  'stack-compact': IconComponent
  'stack': IconComponent
  'star-filled': IconComponent
  'star': IconComponent
  'stop': IconComponent
  'strikethrough': IconComponent
  'string': IconComponent
  'sun': IconComponent
  'sync': IconComponent
  'tablet-device': IconComponent
  'tag': IconComponent
  'tags': IconComponent
  'target': IconComponent
  'task': IconComponent
  'terminal': IconComponent
  'text': IconComponent
  'th-large': IconComponent
  'th-list': IconComponent
  'thumbs-down': IconComponent
  'thumbs-up': IconComponent
  'tiers': IconComponent
  'timeline': IconComponent
  'toggle-arrow-right': IconComponent
  'token': IconComponent
  'transfer': IconComponent
  'translate': IconComponent
  'trash': IconComponent
  'trend-upward': IconComponent
  'triangle-outline': IconComponent
  'trolley': IconComponent
  'truncate': IconComponent
  'twitter': IconComponent
  'ulist': IconComponent
  'unarchive': IconComponent
  'underline': IconComponent
  'undo': IconComponent
  'unknown': IconComponent
  'unlink': IconComponent
  'unlock': IconComponent
  'unpublish': IconComponent
  'upload': IconComponent
  'user': IconComponent
  'users': IconComponent
  'versions': IconComponent
  'video': IconComponent
  'warning-filled': IconComponent
  'warning-outline': IconComponent
  'wrench': IconComponent
}

/**
 * @public
 */
export const icons: IconMap = {
  'access-denied': AccessDeniedIcon,
  'activity': ActivityIcon,
  'add-circle': AddCircleIcon,
  'add-comment': AddCommentIcon,
  'add-document': AddDocumentIcon,
  'add': AddIcon,
  'add-user': AddUserIcon,
  'api': ApiIcon,
  'archive': ArchiveIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-top-right': ArrowTopRightIcon,
  'arrow-up': ArrowUpIcon,
  'asterisk': AsteriskIcon,
  'bar-chart': BarChartIcon,
  'basket': BasketIcon,
  'bell': BellIcon,
  'bill': BillIcon,
  'binary-document': BinaryDocumentIcon,
  'block-content': BlockContentIcon,
  'block-element': BlockElementIcon,
  'blockquote': BlockquoteIcon,
  'bold': BoldIcon,
  'bolt': BoltIcon,
  'book': BookIcon,
  'bookmark-filled': BookmarkFilledIcon,
  'bookmark': BookmarkIcon,
  'bottle': BottleIcon,
  'bug': BugIcon,
  'bulb-filled': BulbFilledIcon,
  'bulb-outline': BulbOutlineIcon,
  'calendar': CalendarIcon,
  'case': CaseIcon,
  'chart-upward': ChartUpwardIcon,
  'checkmark-circle': CheckmarkCircleIcon,
  'checkmark': CheckmarkIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-up': ChevronUpIcon,
  'circle': CircleIcon,
  'clipboard': ClipboardIcon,
  'clipboard-image': ClipboardImageIcon,
  'clock': ClockIcon,
  'close-circle': CloseCircleIcon,
  'close': CloseIcon,
  'code-block': CodeBlockIcon,
  'code': CodeIcon,
  'cog': CogIcon,
  'collapse': CollapseIcon,
  'color-wheel': ColorWheelIcon,
  'comment': CommentIcon,
  'component': ComponentIcon,
  'compose': ComposeIcon,
  'compose-sparkles': ComposeSparklesIcon,
  'confetti': ConfettiIcon,
  'controls': ControlsIcon,
  'copy': CopyIcon,
  'credit-card': CreditCardIcon,
  'crop': CropIcon,
  'cube': CubeIcon,
  'dashboard': DashboardIcon,
  'database': DatabaseIcon,
  'desktop': DesktopIcon,
  'diamond': DiamondIcon,
  'document': DocumentIcon,
  'document-pdf': DocumentPdfIcon,
  'document-remove': DocumentRemoveIcon,
  'document-sheet': DocumentSheetIcon,
  'document-text': DocumentTextIcon,
  'document-video': DocumentVideoIcon,
  'document-word': DocumentWordIcon,
  'document-zip': DocumentZipIcon,
  'documents': DocumentsIcon,
  'dot': DotIcon,
  'double-chevron-down': DoubleChevronDownIcon,
  'double-chevron-left': DoubleChevronLeftIcon,
  'double-chevron-right': DoubleChevronRightIcon,
  'double-chevron-up': DoubleChevronUpIcon,
  'download': DownloadIcon,
  'drag-handle': DragHandleIcon,
  'drop': DropIcon,
  'earth-americas': EarthAmericasIcon,
  'earth-globe': EarthGlobeIcon,
  'edit': EditIcon,
  'ellipsis-horizontal': EllipsisHorizontalIcon,
  'ellipsis-vertical': EllipsisVerticalIcon,
  'empty': EmptyIcon,
  'enter': EnterIcon,
  'enter-right': EnterRightIcon,
  'envelope': EnvelopeIcon,
  'equal': EqualIcon,
  'error-filled': ErrorFilledIcon,
  'error-outline': ErrorOutlineIcon,
  'error-screen': ErrorScreenIcon,
  'expand': ExpandIcon,
  'eye-closed': EyeClosedIcon,
  'eye-open': EyeOpenIcon,
  'face-happy': FaceHappyIcon,
  'face-indifferent': FaceIndifferentIcon,
  'face-sad': FaceSadIcon,
  'feedback': FeedbackIcon,
  'filter': FilterIcon,
  'folder': FolderIcon,
  'generate': GenerateIcon,
  'github': GithubIcon,
  'groq': GroqIcon,
  'hash': HashIcon,
  'heart-filled': HeartFilledIcon,
  'heart': HeartIcon,
  'help-circle': HelpCircleIcon,
  'highlight': HighlightIcon,
  'home': HomeIcon,
  'ice-cream': IceCreamIcon,
  'image': ImageIcon,
  'image-remove': ImageRemoveIcon,
  'images': ImagesIcon,
  'inbox': InboxIcon,
  'info-filled': InfoFilledIcon,
  'info-outline': InfoOutlineIcon,
  'inline-element': InlineElementIcon,
  'inline': InlineIcon,
  'insert-above': InsertAboveIcon,
  'insert-below': InsertBelowIcon,
  'italic': ItalicIcon,
  'joystick': JoystickIcon,
  'json': JsonIcon,
  'launch': LaunchIcon,
  'leave': LeaveIcon,
  'lemon': LemonIcon,
  'link': LinkIcon,
  'link-removed': LinkRemovedIcon,
  'linkedin': LinkedinIcon,
  'list': ListIcon,
  'lock': LockIcon,
  'logo-js': LogoJsIcon,
  'logo-ts': LogoTsIcon,
  'marker': MarkerIcon,
  'marker-removed': MarkerRemovedIcon,
  'master-detail': MasterDetailIcon,
  'menu': MenuIcon,
  'microphone': MicrophoneIcon,
  'microphone-slash': MicrophoneSlashIcon,
  'mobile-device': MobileDeviceIcon,
  'moon': MoonIcon,
  'number': NumberIcon,
  'ok-hand': OkHandIcon,
  'olist': OlistIcon,
  'overage': OverageIcon,
  'package': PackageIcon,
  'panel-left': PanelLeftIcon,
  'panel-right': PanelRightIcon,
  'pause': PauseIcon,
  'pin-filled': PinFilledIcon,
  'pin': PinIcon,
  'pin-removed': PinRemovedIcon,
  'play': PlayIcon,
  'plug': PlugIcon,
  'presentation': PresentationIcon,
  'progress-50': Progress50Icon,
  'progress-75': Progress75Icon,
  'projects': ProjectsIcon,
  'publish': PublishIcon,
  'read-only': ReadOnlyIcon,
  'redo': RedoIcon,
  'refresh': RefreshIcon,
  'remove-circle': RemoveCircleIcon,
  'remove': RemoveIcon,
  'reset': ResetIcon,
  'restore': RestoreIcon,
  'retrieve': RetrieveIcon,
  'retry': RetryIcon,
  'revert': RevertIcon,
  'robot': RobotIcon,
  'rocket': RocketIcon,
  'schema': SchemaIcon,
  'search': SearchIcon,
  'select': SelectIcon,
  'share': ShareIcon,
  'sort': SortIcon,
  'sparkle': SparkleIcon,
  'sparkles': SparklesIcon,
  'spinner': SpinnerIcon,
  'split-horizontal': SplitHorizontalIcon,
  'split-vertical': SplitVerticalIcon,
  'square': SquareIcon,
  'stack-compact': StackCompactIcon,
  'stack': StackIcon,
  'star-filled': StarFilledIcon,
  'star': StarIcon,
  'stop': StopIcon,
  'strikethrough': StrikethroughIcon,
  'string': StringIcon,
  'sun': SunIcon,
  'sync': SyncIcon,
  'tablet-device': TabletDeviceIcon,
  'tag': TagIcon,
  'tags': TagsIcon,
  'target': TargetIcon,
  'task': TaskIcon,
  'terminal': TerminalIcon,
  'text': TextIcon,
  'th-large': ThLargeIcon,
  'th-list': ThListIcon,
  'thumbs-down': ThumbsDownIcon,
  'thumbs-up': ThumbsUpIcon,
  'tiers': TiersIcon,
  'timeline': TimelineIcon,
  'toggle-arrow-right': ToggleArrowRightIcon,
  'token': TokenIcon,
  'transfer': TransferIcon,
  'translate': TranslateIcon,
  'trash': TrashIcon,
  'trend-upward': TrendUpwardIcon,
  'triangle-outline': TriangleOutlineIcon,
  'trolley': TrolleyIcon,
  'truncate': TruncateIcon,
  'twitter': TwitterIcon,
  'ulist': UlistIcon,
  'unarchive': UnarchiveIcon,
  'underline': UnderlineIcon,
  'undo': UndoIcon,
  'unknown': UnknownIcon,
  'unlink': UnlinkIcon,
  'unlock': UnlockIcon,
  'unpublish': UnpublishIcon,
  'upload': UploadIcon,
  'user': UserIcon,
  'users': UsersIcon,
  'versions': VersionsIcon,
  'video': VideoIcon,
  'warning-filled': WarningFilledIcon,
  'warning-outline': WarningOutlineIcon,
  'wrench': WrenchIcon,
}
